import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { actionCreators } from 'src/state/actions/services'
import ServicePane from '../../components/services/ServicePane'
import { getServiceArchiveServiceId, getServiceRestoreServiceId } from '../../state/reducers/services'
import { IServiceStateFilters, IStoreState } from '../../types'

const mapStateToProps = (state: IStoreState, ownProps: RouteComponentProps<any>) => {
  return {
    showArchiveModal: !!getServiceArchiveServiceId(state),
    showRestoreModal: !!getServiceRestoreServiceId(state),
    orgId: state.organizations.currentOrgId,
    routeProps: ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateServiceFilters: (params: IServiceStateFilters) => {
      return dispatch(actionCreators.updateServiceFilters(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicePane)



// WEBPACK FOOTER //
// ./src/containers/services/ServicePane.ts